module.exports = __webpack_public_path__ + "img/ziliao_banner_en.e12ed694.jpg";